import React, { forwardRef } from "react";
import { FormControl } from "react-bootstrap";

const CustomInput = forwardRef(
  (
    {
      className = "",
      id,
      type = "text",
      placeholder,
      name,
      value,
      customObjectKey,
      onClick,
      inputAs = "input",
      readOnly = false,
      checked,
      ...props
    },
    ref
  ) => {
    return (
      <FormControl
        className={className}
        id={id}
        type={type}
        placeholder={placeholder}
        name={name}
        value={type === "checkbox" ? undefined : value}
        checked={type === "checkbox" ? checked : undefined}
        data-validationkey={customObjectKey}
        as={inputAs}
        onClick={onClick}
        readOnly={readOnly}
        ref={ref} // Ensure ref is passed
        {...props}
      />
    );
  }
);

export default CustomInput;
